<template>
  <div class="home-page">
    <div>
      <BannerPage />
    </div>
    <div class="price">
      <priceDisplay />
    </div>
  </div>
</template>

<script>
import BannerPage from '../components/bannerPage.vue';
import priceDisplay from '../components/priceDisplay.vue';
export default {
  name: 'HomePage',
  components: {
    BannerPage,
    priceDisplay
  }
};
</script>

<style scoped>
.home-page {
  background-color: #Fef7f5;
  min-height: 100vh;
  width: 100%;
  margin: 0;
  padding: 10px 0 10px;
}
.price {
  margin-bottom: 10px;
}
</style>